import { css } from 'styled-system/css';
import { Container } from './Container';
import { IsometricScene } from './isometricScene/IsometricScene';
import { Reveal } from './Reveal';
import { SectionHeader } from './SectionHeader';

export function SubstrateSection() {
  return (
    <section
      id="mcp"
      aria-label="The substrate for AI agents"
      className={css({
        position: 'relative',
        paddingTop: { base: '16', md: '28' },
        paddingBottom: { base: '12', md: '16' },
        overflow: 'hidden',
        scrollMarginTop: '20',
      })}
    >
      <Container className={css({ position: 'relative' })}>
        <SectionHeader
          eyebrow="Connectors & MCP"
          title="A substrate for ChatGPT, Claude, and others"
          align="center"
        />
        <Reveal delay={100}>
          <p
            className={css({
              fontSize: { base: 'sm', md: 'base' },
              lineHeight: 'relaxed',
              color: 'text.secondary',
              textAlign: 'center',
              maxWidth: '64ch',
              marginInline: 'auto',
              marginTop: '5',
            })}
          >
            Use Exis as a shared database for your agents. Via MCP or
            Connectors, they read the same grid and make changes through the
            same review gate.
          </p>
        </Reveal>
        <Reveal delay={200}>
          <IsometricScene />
        </Reveal>
      </Container>
    </section>
  );
}
